// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button__container":"Button_button__container__288iA","active":"Button_active__y7gJv"};